'use strict';

function directive(Global) {
    return {
        // restrict: 'A',
        // transclude : true,
        link: function ($scope, element, attrs) {
            let incrimentCountBy = 3;
            // grab the html string from the attrs
            let html = attrs.html;
            // note: we weap the html (markdown) in divs to tell apart the higharchy of the ul > li's
            html += '<div>'+html+'</div>';
            // create an empty element to throw it in
            let el = document.createElement('html');
            el.innerHTML = html; // fill the empty object
            // create empty div that will be added to the element
            let divHolder = document.createElement('div');
            element[0].appendChild(divHolder);
            // select div
            let div =  element[0].querySelector('div');
            // next mark each with a class that will make them easier to style
            let logs = el.querySelectorAll('div > ul > li');
            Array.prototype.forEach.call(logs, function (e, i) {
                if (e.classList) {
                    e.classList.add('logblock');
                } else {
                    e['logblock'] += ' ' + 'logblock';
                }
            });
            let currentOut = 0;
            function addElementsToOutput(number) {
                if ((currentOut + number) < logs.length) {
                    currentOut += number;
                } else {
                    currentOut = logs.length;
                }
                let string = '';
                let array = _.take(logs, currentOut);
                // array = Array.prototype.slice.call(logs, logs.length -1);
                array.forEach(function (e) {
                    string += e.outerHTML;
                })
                return string;
            }
            // 'load more' function toggle
            $scope.loadMoreChangeLog = function () {
                let string = addElementsToOutput(incrimentCountBy);
                div.innerHTML = string;
            }
            // 'load more' function toggle
            $scope.goBack = function () {
                window.history.back();
            }
            let string = addElementsToOutput(incrimentCountBy);
            div.innerHTML = string;
        }
    };
}

directive.$inject = ['Global'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/changelog/directives/renderhtml/renderhtml.js
 **/